import React, { Component, Fragment } from 'react';
import {
    Container,
    Button,
    Row,
    Col,
    Input,
    Form, FormGroup, Label
} from 'reactstrap';
import './Links.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTrashAlt, faTimes, faGlobe, faEdit } from '@fortawesome/free-solid-svg-icons';
import CollapseCard from '../CollapseCard/CollapseCard';
import CompanyContext from '../../auth/CompanyContext';
import ConfirmButton from '../Modal/ConfirmButton';
import { Prompt } from 'react-router-dom';

class Links extends Component {
    static contextType = CompanyContext;

    constructor(props) {

        super(props);
        this.blankLink = {
            id: 0,
            link: '',
            description: '',
            global: true,
            order: 0,
        }
        this.state = {
            links: [],
            newLink: { ...this.blankLink },
            editLink: { ...this.blankLink },
            isLoaded: false,
            unsavedChanges: false
        };

    }

    componentDidMount() {
        this.getLinks();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    getLinks = () => {
        fetch('/api/links/' + this.props.user, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState((prevState, props) => {
                    return {
                        links: results.data,
                        isLoaded: true
                    };
                });
            });
    }

    onChange = (e, type) => {
        e.persist();
        this.setState((prevState) => {
            let thisLink = (type === 'edit') ? prevState.editLink : prevState.newLink;
            switch (e.target.name) {
                case "global":
                    thisLink[e.target.name] = !thisLink[e.target.name];
                    break;
                default:
                    thisLink[e.target.name] = e.target.value;
            }
            return (type === 'edit') ? { editLink: thisLink, unsavedChanges: true } : { newLink: thisLink, unsavedChanges: true };
        });
    }

    onEdit = (id) => {
        if (!this.props.checkPermission('Edit Links')) return;
        const link = [...this.state.links].filter(item => item.ID === id)[0];
        this.setState(() => {
            return {
                editLink: {
                    id: id,
                    link: link.Link,
                    description: link.Description,
                    global: link.Global,
                    order: link.Order
                }
            }
        })
    }

    onDelete = (id) => {
        if (!this.props.checkPermission('Delete Links')) return;
        fetch('/api/links/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        unsavedChanges: false,
                        editLink: { ...this.blankLink }
                    }, () => this.getLinks());
                }
            });
    }

    handleCancel = () => {
        this.setState({
            unsavedChanges: false,
            editLink: { ...this.blankLink },
        })
    }

    handleEdit = () => {
        fetch('/api/links/' + this.state.editLink.id, {
            method: 'PUT',
            body: JSON.stringify({
                link: this.state.editLink.link,
                description: this.state.editLink.description,
                global: this.state.editLink.global,
                order: this.state.editLink.order,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editLink: { ...this.blankLink },
                        unsavedChanges: false
                    }, () => this.getLinks());
                }
            });
    }

    handleAdd = (e) => {
        let newOrder = Math.max(...this.state.links.map(i => i['Order']), 0) + 10;
        fetch('/api/links/', {
            method: 'POST',
            body: JSON.stringify({
                link: this.state.newLink.link,
                description: this.state.newLink.description,
                global: this.state.newLink.global,
                auth0: this.props.user,
                order: newOrder
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newLink: { ...this.blankLink },
                        unsavedChanges: false
                    }, () => this.getLinks());
                }
            });
    }

    standardRow = (link) => {
        return (<>
            <Row className={"links py-2"} >
                <Col md={10} className="text-left">
                    <Row className="linksLink"><Col>
                        <a href={link.Link} rel="noopener noreferrer" target="_blank" >{link.Link}</a>
                    </Col>
                    </Row>
                    <Row className="linksDescription"><Col>
                        {link['Description']}
                    </Col>
                    </Row>
                </Col>
                <Col md={2} className="text-right">
                    {(link['Global']) ? <FontAwesomeIcon className="iconGlobe mr-3" icon={faGlobe} /> : <></>}
                    {(this.props.checkPermission('Edit Links')) ?
                        <Button title="Edit Link" className="mr-0" color="primary" onClick={() => this.onEdit(link.ID)}>
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                        : <></>}
                </Col>
            </Row>
        </>
        )
    }

    editRow = (link) => {
        return (
            <Row className="editRow adminRow">
                <Col className="text-left col-md-8">
                    <Form inline>
                        <FormGroup className="pr-2">
                            <Input
                                placeholder="Link"
                                type="text"
                                id={"edit-link" + link.ID}
                                name="link"
                                value={this.state.editLink.link}
                                onChange={e => this.onChange(e, 'edit')} />
                        </FormGroup>
                        <FormGroup className="px-2">
                            <Input
                                placeholder="Description"
                                type={"edit-text" + link.ID}
                                id="link-edit-description"
                                name="description"
                                value={this.state.editLink.description}
                                onChange={e => this.onChange(e, 'edit')} />
                        </FormGroup>
                        <FormGroup className="px-2">
                            <Input
                                type="checkbox"
                                id={"link-global" + link.ID}
                                name="global"
                                checked={this.state.editLink.global}
                                onChange={e => this.onChange(e, 'edit')} />
                            <Label for={"link-global" + link.ID}>
                                Global
                            </Label>
                        </FormGroup>
                    </Form>
                </Col>
                <Col className="text-right col-md-4">
                    <Button className="mx-1" color="success" onClick={this.handleEdit}>
                        <FontAwesomeIcon icon={faCheck} />
                    </Button>
                    {(this.props.checkPermission('Delete Links')) ?
                        <ConfirmButton title="Delete Link" className="mx-3" color="danger" onClick={() => this.onDelete(link.ID)}>
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </ConfirmButton> : <></>}
                    <Button title="Cancel" className="mx-1" color="secondary" onClick={this.handleCancel}>
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
            </Row>
        )
    }

    addRow = () => {
        return (<Row className="py-4 text-left align-items-bottom">
            <Col>
                <Form inline>
                    <FormGroup className="pr-2">
                        Add New Link
                    </FormGroup>
                    <FormGroup className="px-2">
                        <Input
                            placeholder="Link"
                            type="text"
                            id="link"
                            name="link"
                            value={this.state.newLink.link}
                            onChange={e => this.onChange(e)} />
                    </FormGroup>
                    <FormGroup className="px-2">
                        <Input
                            placeholder="Description"
                            type="text"
                            id="link-add-description"
                            name="description"
                            value={this.state.newLink.description}
                            onChange={e => this.onChange(e)} />
                    </FormGroup>
                    <FormGroup className="px-2">
                        <Input
                            type="checkbox"
                            id="link-global"
                            name="global"
                            checked={this.state.newLink.global}
                            onChange={e => this.onChange(e)} />
                        <Label for="link-global">
                            Global
                        </Label>
                    </FormGroup>
                </Form>
            </Col>
            <Col className="text-right col-md-3">
                <Button disabled={this.state.newLink.link === ''} color="primary" onClick={this.handleAdd}>Add Link</Button>
            </Col>
        </Row>
        )
    }

    render() {
        return (
            <Container fluid>
                <Prompt
                    when={this.state.unsavedChanges}
                    message="You have unsaved changes, are you sure you want to leave?"
                />
                <CollapseCard title="Links" open={false} header="h3">
                    {this.state.links.map(link => (
                        <Fragment key={link.ID}>{this.state.editLink.id === link.ID ? this.editRow(link) : this.standardRow(link)}</Fragment>
                    ))}
                    {(this.props.checkPermission('Add Links')) ? this.addRow() : <></>}
                </CollapseCard>
            </Container>
        );
    }
}

export default Links;